import { ApiError } from '@counsel-project/client-utils'
import Cookies from 'js-cookie'
import logout from './logout'

const checkToken = async (allowMissing?: boolean): Promise<boolean> => {
  const expiresAt = Cookies.get('expiresAt')
  if (!expiresAt) {
    if (allowMissing) return false
    await logout(true)
    throw new ApiError('Logged out due to inactivity')
  }

  const expiresAtDate = new Date(parseInt(expiresAt) || 0)
  const now = new Date()

  // Check if token has already expired
  if (expiresAtDate.getTime() < now.getTime()) {
    if (allowMissing) return false
    await logout(true)
    throw new ApiError('Logged out due to inactivity')
  }

  // Token is valid
  return true
}

export default checkToken
